module.exports = __webpack_public_path__ + "img/product32_img04.b6b04814.png";